import * as React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { AppContextProvider } from './App';

interface ProtectedRouteProps {
    children?: JSX.Element;
    redirectPath?: string;
}

export function ProtectedRoute({ children, redirectPath = '/' }: ProtectedRouteProps): JSX.Element {
    const { user, loading } = React.useContext(AppContextProvider);

    if (loading) {
        return <div className="white-text ma-2">Loading...</div>;
    }

    if (!user) {
        return <Navigate to={redirectPath} replace />;
    }

    return children ? children : <Outlet />;
}
